import React from 'react';
import { MarkdownNooco } from '../../MarkdownNooco';

type FixedDisplayProps = {
  text: string;
  secondText?: string;
  img?: string;
  imgPosition: 'top' | 'center' | 'bottom';
};

export const FixedDisplay = ({
  text,
  secondText,
  img,
  imgPosition,
}: FixedDisplayProps) => {
  function renderContentDepandingOnPlacement(imgPosition: string) {
    switch (imgPosition) {
      case 'top':
        return (
          <>
            <img src={img} alt="fixed" style={{ width: '50%' }} />
            <MarkdownNooco text={text} />;
          </>
        );
      case 'center':
        return (
          <>
            <MarkdownNooco text={text} />;
            <img src={img} alt="fixed" style={{ width: '50%' }} />
            <MarkdownNooco text={secondText} />;
          </>
        );
      case 'bottom':
        return (
          <>
            <MarkdownNooco text={text} />;
            <img src={img} alt="fixed" style={{ width: '50%' }} />
          </>
        );
      default:
        return <p></p>;
    }
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: img ? 'center' : 'start',
        pageBreakInside: 'avoid',
      }}
    >
      {img ? (
        renderContentDepandingOnPlacement(imgPosition)
      ) : (
        <MarkdownNooco text={text} />
      )}
    </div>
  );
};
